import React from 'react';
import BlogIcon from './pgmolblog.png';

const PgmolBlog = () => (
  <img src={BlogIcon} alt="blog" height={32} width={32} />
);

export default PgmolBlog;
